import { hapticFeedback } from '@telegram-apps/sdk';
import { useStore } from '@/store/useStore';

// Define the interface for the window object to include Telegram WebApp


export function useHapticFeedback() {
    const { hapticsEnabled } = useStore();

    // No explicit mount needed for hapticFeedback in this version of SDK
    // It is auto-initialized or static.

    const impactOccurred = (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => {
        if (!hapticsEnabled) return;
        try {
            // Try SDK first. We don't check .isAvailable() because it might be
            // false negatives on some Android devices/webviews where it actually works.
            hapticFeedback.impactOccurred(style);
            return;
        } catch {
            // SDK threw error, proceed to fallback
        }

        // Fallback to window.Telegram.WebApp (Native Object)
        if (window.Telegram?.WebApp?.HapticFeedback) {
            window.Telegram.WebApp.HapticFeedback.impactOccurred(style);
        }
    };

    const notificationOccurred = (type: 'error' | 'success' | 'warning') => {
        if (!hapticsEnabled) return;
        try {
            hapticFeedback.notificationOccurred(type);
            return;
        } catch {
            // Ignore
        }

        if (window.Telegram?.WebApp?.HapticFeedback) {
            window.Telegram.WebApp.HapticFeedback.notificationOccurred(type);
        }
    };

    const selectionChanged = () => {
        if (!hapticsEnabled) return;
        try {
            hapticFeedback.selectionChanged();
            return;
        } catch {
            // Ignore
        }

        if (window.Telegram?.WebApp?.HapticFeedback) {
            window.Telegram.WebApp.HapticFeedback.selectionChanged();
        }
    };

    return {
        impactOccurred,
        notificationOccurred,
        selectionChanged,
    };
}
